import { Grid, IconButton, Tooltip } from '@material-ui/core'
import Programa from '../../components/Programa/Programa'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { Cadastro } from './Cadastro'
import { metodoPrograma } from '../../components/api'
import Table from '../../components/Table/Table'
import { format } from 'date-fns';

const Notificacao = () => {

  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [objeto, setObjeto] = useState([])

  const getLista = useCallback(() => {
    metodoPrograma('lista', {}).then((res) => {
      if (res.status) {
        if (res.lista) {
          setLista(res.lista)
        } else {
          setLista([])
        }
      }
    })
  }, [])

  const handleClick = (_, linha) => {
    setObjeto(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setTela('lista')
    setObjeto([])
    getLista()
  }

  useEffect(() => {
    getLista()
  }, [getLista])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar Estado">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlNotificacaoUsuario" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              dados={lista}
              head={['User', 'Date', 'Title', 'Content']}
              line={(l) => [l?.[1]?.[1], format(l?.[2], 'MM/dd/yyyy - MM:SS'), l?.[3], l?.[4] ]}
              onClick={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Cadastro {...{ objeto, voltar }} />
      )}
    </Programa>
  )
}

export default Notificacao
